import {map, mapfind} from '@republic/foundation/lang/array';
import ErrorsStream from '../../core/streams/ErrorsStream';

const errors = ErrorsStream.provide;

export default (auth, offers) => (
    (auth && auth.token && auth.id && offers && offers.data && offers.data.length) ?
        (fetch(
            '/fractus/p/stratus/rest/v3/orders',
            {
                method: 'POST',
                body: (
                    JSON.stringify({
                        submitter: {
                            uuid: auth.id
                        },
                        order_lines: (
                            map(offers.data,
                                offer => ({
                                    offer: {
                                        ref_id: offer.id
                                    },
                                    order_items: [
                                        mapfind(
                                            offers.raw,
                                            ({offer_components: components, ref_id: id}) => {
                                                if (id === offer.id) {
                                                    return (
                                                        mapfind(
                                                            components,
                                                            ({offer_items: items}) => (
                                                                mapfind(
                                                                    items,
                                                                    ({id, item: {sku}}) => {
                                                                        if (sku === offer.sku) {
                                                                            return {
                                                                                offer_item: {
                                                                                    id
                                                                                }
                                                                            };
                                                                        }
                                                                    }))));
                                                }
                                            })
                                    ]
                                })))
                    })),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Authorization: `Bearer ${auth.token}`
                }
            })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                if (response.status === 503) {
                    errors.display(
                        'maintenance',
                        'Our site is going down for maintenance',
                        'Refresh the page',
                        () => {
                            window.location.reload(true);
                        });
                } else if (response.status === 403) {
                    errors.display(
                        'account/submit-cancellation/error',
                        'You do not have permission to cancel service. Please log out and ' +
                        'ask the account owner to log in and complete the cancellation.',
                        'OK');
                }
                return Promise.reject();
            }
        })) :
        Promise.resolve());
